import React, { useState, useRef, useEffect } from 'react';
import I18n from 'i18n-js';
import { DialogContentText, DialogActions } from '@material-ui/core';
import MuiButton from '@material-ui/core/Button';
import Button from '../generic/Button.js';
import { ReactComponent as MuteAll } from '../../assets/mute_all.svg';

const MUTE_TIMEOUT = 700;

const MuteAllDialog = ({ dialogId, onClose, onEvent }) => {
  const buttonRef = useRef(null);
  const [disabled, setDisabled] = useState(false);
  const timeout = useRef(null);

  const handleClick = () => {
    setDisabled(true);
    clearTimeout(timeout);
    timeout.current = setTimeout(() => {
      setDisabled(false);
      onClose();
      timeout.current = null;
    }, MUTE_TIMEOUT);
    onEvent({ type: 'request_stfu' });
  };

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.focus();
    }
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);

  return (
    <>
      <DialogContentText id={dialogId + '-desc'} tabIndex={0}>
        {I18n.t('dialog:mute_all:description')}
      </DialogContentText>
      <DialogActions>
        <MuiButton
          variant="text"
          color="secondary"
          onClick={onClose}
          ref={buttonRef}
        >
          {I18n.t('label:cancel')}
        </MuiButton>
        <Button icon={<MuteAll />} disabled={disabled} onClick={handleClick}>
          {I18n.t(disabled ? 'label:muted' : 'participants:mute_all')}
        </Button>
      </DialogActions>
    </>
  );
};

export default MuteAllDialog;
